"use client";

import { useState,useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Navbar from "../../../components/navbar";
import Footer from "../../../components/footer";
import FormInput from "../../../components/FormInput";
import Button from "../../../components/Button";
import MultiSelectDropdown from "../../../components/MultiSelectDropdown";
import FileInput from "../../../components/FileInput";
import Checkbox from "../../../components/Checkbox";
import styles from "../../dashboard/css/dashboard.module.css";
import formStyles from "../css/addUser.module.css";
import { addUser, getRolesDetailed as apiGetRolesDetailed, uploadUserDoc, previewFrontShopCode } from "../../../api/userManagement/userManagementApi";
import { getBranches as apiGetBranches } from "../../../api/userManagement/userManagementApi";
import UserValidationModal from "../components/UserValidationModal";

export default function AddUser() {
  const navigate = useNavigate();
  const location = useLocation();
  const branchcode = location.state?.branchcode || "";

  const [formData, setFormData] = useState({first_name: "", last_name: "", employee_number: "",  role: "", roleId: null, roleIds: [], branchcodes: [], id_number: "", dob: "", phone_number: "",  home_address: "",  email: "",  password: "", license_number: "", certification: "", cert_doc: null, pcdt: false, frontshopcode: "",
  });

  const [submitting, setSubmitting] = useState(false);
  const [roles, setRoles] = useState([]);
  const [branches, setBranches] = useState([]);
  const [errorOpen, setErrorOpen] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);
  const [idError, setIdError] = useState("");

  const humanizeUserCreateError = (error) => {
    const messages = [];
    const raw = error?.message || "";
    const lower = raw.toLowerCase();

    if (lower.includes("unique") || lower.includes("duplicate")) {
      if (lower.includes("email")) messages.push("Email already exists");
      if (lower.includes("idnumber") || lower.includes("id_number") || lower.includes("id number")) messages.push("ID number already exists");
      if ((lower.includes("employee") && lower.includes("number")) || lower.includes("employee_number")) messages.push("Employee number already exists");
      if (messages.length === 0) messages.push("One or more fields must be unique and already exist");
    } else if (raw) {
      messages.push(raw);
    } else {
      messages.push("Failed to add user");
    }
    return messages;
  };
  useEffect(() => {
    (async () => {
      try {
        const data = await apiGetRolesDetailed();
        setRoles(Array.isArray(data) ? data : []);
      } catch (e) {
        console.error("Failed to load roles:", e);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const data = await apiGetBranches();
        setBranches(Array.isArray(data) ? data : []);
      } catch (e) {
        console.error("Failed to load branches:", e);
        setBranches([]);
      }
    })();
  }, []);
  const handleChange = (name) => (eOrValue) => {
    if (name === "cert_doc") {
      setFormData({ ...formData, [name]: eOrValue.target.files[0] });
    } else if (name === "pcdt") {
      setFormData({ ...formData, [name]: eOrValue.target.checked });
    } else if (eOrValue && eOrValue.target) {
      let value = eOrValue.target.value;
      if (name === "id_number") {
        // Allow only digits, max 13
        value = value.replace(/\D/g, "").slice(0, 13);
      }
      if (name === "phone_number") {
        // Allow only digits, max 10
        value = value.replace(/\D/g, "").slice(0, 10);
      }
      if (name === "password") {
        // Limit to max 8 chars (can include anything)
        value = value.slice(0, 8);
      }
      const parseSaIdDob = (id) => {
        if (!/^[0-9]{13}$/.test(id)) return "";
        const yy = parseInt(id.slice(0, 2), 10);
        const mm = parseInt(id.slice(2, 4), 10);
        const dd = parseInt(id.slice(4, 6), 10);
        if (mm < 1 || mm > 12 || dd < 1 || dd > 31) return "";
        const currentYear = new Date().getFullYear() % 100;
        const century = yy <= currentYear ? 2000 : 1900;
        const fullYear = century + yy;
        const iso = `${fullYear.toString().padStart(4, '0')}-${String(mm).padStart(2, '0')}-${String(dd).padStart(2, '0')}`;
        const d = new Date(iso);
        if (Number.isNaN(d.getTime())) return "";
        if (d.getUTCFullYear() !== fullYear || (d.getUTCMonth() + 1) !== mm || d.getUTCDate() !== dd) return "";
        return iso;
      };

      if (name === "id_number") {
        const maybeDob = parseSaIdDob(value);
        if (maybeDob) {
          setFormData({ ...formData, [name]: value, dob: maybeDob });
          return;
        }
        if (value.length === 0) {
          setFormData({ ...formData, [name]: "", dob: "" });
          return;
        }
        if (value.length >= 4) {
          const mm = parseInt(value.slice(2, 4), 10);
          if (!(mm >= 1 && mm <= 12)) {
            setIdError("Invalid ID format: month must be between 01 and 12");
          } else if (value.length >= 6) {
            const dd = parseInt(value.slice(4, 6), 10);
            if (!(dd >= 1 && dd <= 31)) {
              setIdError("Invalid ID format: day must be between 01 and 31");
            } else {
              if (idError) setIdError("");
            }
          } else {
            if (idError) setIdError("");
          }
        } else {
          if (idError) setIdError("");
        }
      }

      setFormData({ ...formData, [name]: value });
    } else {
      // Dropdown or custom component
      const value = eOrValue;
      if (name === "roleIds") {
        const nextRoleIds = Array.isArray(value) ? value : [];
        const primaryRoleId = nextRoleIds.length ? Number(nextRoleIds[0]) : null;
        const primaryRoleName = primaryRoleId
          ? (roles.find((r) => Number(r.roleid) === primaryRoleId)?.rolename || "")
          : "";
        const needsFrontShopPin = nextRoleIds.some((rid) => {
          const n = Number(rid);
          return n === 3 || n === 8 || n === 9;
        });

        setFormData((prev) => ({
          ...prev,
          roleIds: nextRoleIds.map((r) => Number(r)).filter((n) => Number.isInteger(n)),
          roleId: primaryRoleId,
          role: primaryRoleName,
        }));

        if (needsFrontShopPin) {
          (async () => {
            try {
              const code = await previewFrontShopCode();
              const pin = (code || "").toString().replace(/\D/g, "").slice(0, 4);
              setFormData((prev) => ({ ...prev, frontshopcode: pin }));
            } catch (e) {
              console.error("Failed to preview front shop PIN", e);
              setFormData((prev) => ({ ...prev, frontshopcode: "" }));
            }
          })();
        } else {
          setFormData((prev) => ({ ...prev, frontshopcode: "" }));
        }
        return;
      }
      if (name === "role") {
        const selected = roles.find((r) => r.rolename === value);
        const roleId = selected ? selected.roleid : null;
        setFormData((prev) => ({ ...prev, role: value, roleId, roleIds: roleId ? [roleId] : [] }));
        return;
      }

      if (name === "branchcodes") {
        const nextCodes = Array.isArray(value) ? value : [];
        const cleaned = Array.from(new Set(nextCodes.map((c) => String(c || "").trim()).filter(Boolean)));
        setFormData((prev) => ({
          ...prev,
          branchcodes: cleaned,
        }));
        return;
      }

      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Clear any previous inline ID errors
    if (idError) setIdError("");
    const isFrontShop = formData.roleId === 9;
    if (!formData.first_name?.trim() || !formData.last_name?.trim() || (!isFrontShop && !formData.email?.trim())) {
      alert("First name, last name, and email are required");
      return;
    }
    if (!Array.isArray(formData.roleIds) || formData.roleIds.length === 0) {
      alert("Please select at least one role");
      return;
    }
    if (!isFrontShop && (!formData.password || formData.password.trim().length === 0)) {
      alert("Password is required");
      return;
    }
    try {
      setSubmitting(true);
      const cleanedBranchCodes = Array.isArray(formData.branchcodes)
        ? Array.from(new Set(formData.branchcodes.map((c) => String(c || "").trim()).filter(Boolean)))
        : [];
      const effectiveBranchCodes = cleanedBranchCodes.length ? cleanedBranchCodes : (branchcode ? [branchcode] : []);
      const primaryBranchCode = branchcode || effectiveBranchCodes[0] || "";
      if (!primaryBranchCode) {
        alert("Please select at least one branch");
        return;
      }
      const payload = {
        ...formData,
        role: (formData.role || "").trim(),
        roleIds: Array.isArray(formData.roleIds) ? formData.roleIds : [],
        branchcode: primaryBranchCode,
        branchcodes: effectiveBranchCodes,
      };
      delete payload.cert_doc; // Ignoring cert_doc upload per requirement
      // Optional: upload certification document; do not write URL into certification input
      if (formData.cert_doc && formData.employee_number) {
        try {
          const url = await uploadUserDoc(formData.employee_number, formData.cert_doc);
          if (url) payload.docurl = url; // store separately from certification
        } catch (uploadErr) {
          console.error("User doc upload failed:", uploadErr);
        }
      }
      const res = await addUser(payload);
      console.log("User created:", res);
      navigate(-1);
    } catch (err) {
      console.error("Failed to add user:", err);
      const resp = err?.response;
      const data = resp?.data;
      // If the backend SA ID validator rejected the ID, show the reason inline
      if (
        resp?.status === 400 &&
        data &&
        (typeof data?.error === "string" && data.error.toLowerCase().includes("invalid id number") ||
         typeof data?.reason === "string")
      ) {
        setIdError(data.reason || data.error || "Invalid ID number");
        return;
      }
      const msgs = humanizeUserCreateError(err);
      setErrorMessages(msgs);
      setErrorOpen(true);
    } finally {
      setSubmitting(false);
    }
  };

  const roleOptionsDetailed = roles.map((r) => ({ value: r.roleid, label: r.rolename }));
  const branchOptionsDetailed = branches.map((b) => ({ value: b.branchcode, label: b.branchname }));

  return (
    <div className={styles.app}>
      <div className={styles.mainContainer}>
        <Navbar />
        <main className={styles.content}>
          <h1 className={formStyles.pageTitle}>Add User</h1>
          <form className={formStyles.formContainer} onSubmit={handleSubmit}>
            <div className={formStyles.formRow}>
              <FormInput
                label="First Name"
                name="first_name"
                value={formData.first_name}
                onChange={handleChange("first_name")}
              />
              <FormInput
                label="Last Name"
                name="last_name"
                value={formData.last_name}
                onChange={handleChange("last_name")}
              />
              <FormInput
                label="Employee Number"
                name="employee_number"
                value={formData.employee_number}
                onChange={handleChange("employee_number")}
              />
              <MultiSelectDropdown
                label="Role"
                name="roleIds"
                options={roleOptionsDetailed}
                value={formData.roleIds}
                onChange={handleChange("roleIds")}
                placeholder="Select Role(s)"
                maxVisible={3}
              />
              <MultiSelectDropdown
                label="Branch"
                name="branchcodes"
                options={branchOptionsDetailed}
                value={Array.isArray(formData.branchcodes) ? formData.branchcodes : (branchcode ? [branchcode] : [])}
                onChange={handleChange("branchcodes")}
                placeholder="Select Branch(es)"
                maxVisible={3}
              />
            </div>

            <hr className={formStyles.sectionDivider} />
            <div className={formStyles.formRow}>
              <div>
                <FormInput
                  label="ID Number"
                  name="id_number"
                  value={formData.id_number}
                  onChange={handleChange("id_number")}
                  placeholder="Enter 13-digit ID number"
                />
                {idError && (
                  <small style={{ color: "#b00020", display: "block", marginTop: 4 }}>{idError}</small>
                )}
              </div>
              {(Array.isArray(formData.roleIds) ? formData.roleIds : []).some((rid) => [3, 8, 9].includes(Number(rid))) && (
                <FormInput
                  label="Front Shop PIN"
                  name="frontshopcode"
                  value={formData.frontshopcode}
                  onChange={handleChange("frontshopcode")}
                  placeholder="Auto-generated"
                  disabled
                />
              )}
              <FormInput
                label="Date of Birth"
                type="date"
                name="dob"
                value={formData.dob}
                onChange={handleChange("dob")}
                disabled
              />
              <FormInput
                label="Phone Number"
                name="phone_number"
                value={formData.phone_number}
                onChange={handleChange("phone_number")}
                placeholder="Enter 10-digit number"
              />
            </div>

            <hr className={formStyles.sectionDivider} />

            {/* --- Third Row --- */}
            <div className={formStyles.formRow}>
              <FormInput
                label="Home Address"
                name="home_address"
                value={formData.home_address}
                onChange={handleChange("home_address")}
              />
              {formData.roleId !== 9 && (
                <FormInput
                  label="Email"
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange("email")}
                />
              )}
              {formData.roleId !== 9 && (
                <FormInput
                  label="Password"
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange("password")}
                  placeholder="Max 8 characters"
                />
              )}
              <FormInput
                label="License/Reg Number"
                name="license_number"
                value={formData.license_number}
                onChange={handleChange("license_number")}
              />
            </div>

            <hr className={formStyles.sectionDivider} />
            <div className={formStyles.formRow2}>
              <FormInput
                label="Certification"
                name="certification"
                value={formData.certification}
                onChange={handleChange("certification")}
              />
              <FileInput
                label="Certification (PDF/Image)"
                name="cert_doc"
                id="cert_doc"
                value={formData.cert_doc}
                onChange={handleChange("cert_doc")}
                accept=".pdf,.jpg,.jpeg,.png"
                wide={true}
              />
            </div>
            <div className={formStyles.formActions}>
              <Button variant="primary" type="submit" disabled={submitting}>
                {submitting ? "Saving..." : "Save"}
              </Button>
              <Button
                variant="secondary"
                type="button"
                onClick={() => navigate(-1)}
              >
                Cancel
              </Button>
            </div>
          </form>
        </main>

        <div className={styles.footerWrapper}>
          <Footer />
        </div>
      </div>
      <UserValidationModal
        isOpen={errorOpen}
        onClose={() => setErrorOpen(false)}
        messages={errorMessages}
      />
    </div>
  );
}
